import React from 'react';
import { uniqueId } from 'lodash';
import ValidationControl from '../ValidationControl/ValidationControl';
import DropdownControl from './DropdownControl';

export interface IProps {
  value: string;
  name?: string;
  isReadonly?: boolean;
  onChange: (event: any) => void;
  displayField: string;
  valueField: string;
  groupCode?: string;
  selectOption?: string;
  selectOptionValue?: string;
  isRequired?: boolean;
  isValid?: boolean;
  validationMessage?: string;
  style?: any;
  useFilter?: string;
  data: any[];
}

export class DropDownControlCodeTableObject extends React.Component<IProps> {
  private uid = uniqueId('dropDownControlObject_');
  public render() {
    return (
      <table>
        <tbody>
          <tr>
            <td>
              <ValidationControl
                {...this.props}
                isValid={this.props.isValid !== undefined ? this.props.isValid : true}
                message={this.props.validationMessage ? this.props.validationMessage : 'An input is required'}
                uid={this.uid}
              />
            </td>
            <td>
              <DropdownControl
                value={this.props.value}
                name={this.props.name}
                isReadonly={this.props.isReadonly}
                data={this.props.data}
                displayField={this.props.displayField}
                valueField={this.props.valueField}
                onChange={this.props.onChange}
                style={this.props.style}
              />
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default DropDownControlCodeTableObject;
